import React from "react";
import map from "lodash/map";
import ExercisePreview from "./exercise-preview";

const WorkoutPreview = (props) => {
  const {
    exercises = [],
    workoutNumber,
    locals,
    sessions,
    notSingleWorkout,
  } = props;
  const week = locals.query?.week ?? 0;

  const exerciseIds = exercises.map((exercise) => exercise._id);

  const sessionToFindWorkName = sessions.find(
    (item) =>
      Number(week) === Number(item.week) &&
      arraysEqual(item.exercises, exerciseIds)
  );

  const workoutName =
    sessionToFindWorkName && sessionToFindWorkName.workoutName
      ? `Workout ${workoutNumber} - ${sessionToFindWorkName.workoutName}`
      : `Workout ${workoutNumber}`;

  return (
    <article className="Workout-Preview">
      <header className={`${!notSingleWorkout ? "!top-0" : ""}`}>
        <p className="s2">
          {notSingleWorkout ? workoutName : "Single Workout"}
        </p>
      </header>
      <div className={`body workout-${workoutNumber}-list`}>
        <ul className="exercises-list">
          {map(exercises, (exercise, idx) => {
            if (!exercise) return null;
            return (
              <ExercisePreview
                exercise={exercise}
                exercises={exercises}
                exerciseOrder={idx}
                locals={locals}
                key={exercise._id}
              />
            );
          })}
        </ul>
      </div>
    </article>
  );
};

export default WorkoutPreview;

/**
 * Function to check if two arrays are equal
 * @param {*} arr1
 * @param {*} arr2
 * @returns
 */
const arraysEqual = (arr1, arr2) => {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;
  return arr1.every((val) => arr2.includes(val));
};
